import { ElegantExcludedProductIds } from '../core/enums/elegantExcludedProductIds';
import { QueryParams } from '../core/enums/queryParams';

export const shouldExcludeProductIdFromElegantExperience = (
	locationSearch = location.search
): boolean =>
	Object.values(ElegantExcludedProductIds).some(productId => locationSearch.includes(`${QueryParams.ProductId}=${productId}`));
